import { render, staticRenderFns } from "./Bayonet.vue?vue&type=template&id=4c242a40"
import script from "./Bayonet.vue?vue&type=script&lang=js"
export * from "./Bayonet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports